import i18n from "src/i18n";

import { ROLES } from "@constants/index";

// todo: Move all nav links to "constants" directory

export const getQueueNavLinks = (canAccessPath: (path: string) => boolean) => {
  const links = [
    {
      title: i18n.t("incoming"),
      link: "incoming",
      isEnabled: true, //* NB: Doctors with receptionist roles can see "incoming" page if they somehow get access to the URL
      roles: [ROLES.ADMIN, ROLES.RECEPTIONIST],
    },
    {
      title: i18n.t("booked"),
      link: "booked",
      isEnabled: true,
      roles: [ROLES.ADMIN, ROLES.RECEPTIONIST, ROLES.DOCTOR],
    },
  ];

  // Filter links based on roles
  const filteredLinks = links.filter(link => {
    return canAccessPath("queue/" + link.link);
  });

  return filteredLinks;
};
